import {signOut} from 'aws-amplify/auth';
import {config} from '../config/amplify/auth';

// FNP-1685: a bare signOut() REJECTS on every deployed stage. Amplify clears the
// tokens first, then refuses the logout redirect because redirectSignOut is the
// portal, a different origin (InvalidOriginException). Naming this stage's
// portal as the preferred redirect makes Amplify send the browser through the
// broker's /logout to the portal; it sets window.location itself and resolves.
// Only a rejection leaves for '/' here: redirecting after a resolved signOut()
// would override Amplify's navigation.
export const signOutToPortal = async () => {
    const redirectUrl = config?.Cognito.loginWith?.oauth?.redirectSignOut[0];
    try {
        await signOut({global: false, oauth: {redirectUrl}});
    } catch (error) {
        console.error('Sign out did not complete cleanly', error);
        window.location.href = '/';
    }
};
